import React from 'react';
 import Icon from'../../../components/AppIcon';
 import Button from'../../../components/ui/Button';

const PricingCard = ({ plan, displayPrice, billingCycle, isCurrentPlan, isProcessing, onSelect }) => {
  const isEnterprise = plan?.tier === 'enterprise'
  const isFree = plan?.tier === 'free'
  const isPremium = plan?.tier === 'draftiq_plus'

  const getButtonText = () => {
    if (isCurrentPlan) return 'Current Plan'
    if (isProcessing) return 'Processing...'
    if (isFree) return 'Get Started'
    if (isEnterprise) return 'Contact Sales'
    return 'Subscribe Now'
  }

  const handleClick = () => {
    if (isCurrentPlan || isProcessing) return
    onSelect()
  }

  return (
    <div
      className={`
        relative elevated-card rounded-3xl p-8 transition-smooth hover-lift
        ${
          isPremium
            ? 'border-2 border-primary shadow-glass-lg ring-2 ring-primary/20 scale-105'
            : 'border border-border/50'
        }
        ${
          isCurrentPlan
            ? 'ring-2 ring-green-500/50 border-green-500/50' :''
        }
        backdrop-blur-sm bg-gradient-to-br from-card/95 to-card/80
      `}
    >
      {isPremium && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
          <div className="glass-strong px-6 py-2 rounded-full shadow-glass">
            <span className="bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent font-bold text-sm">
              ⭐ Most Popular
            </span>
          </div>
        </div>
      )}

      {isCurrentPlan && (
        <div className="absolute -top-3 right-6 z-10">
          <span className="glass-strong bg-green-500/90 text-white px-4 py-1.5 rounded-full text-xs font-bold flex items-center gap-1.5 shadow-glass">
            <Icon name="Check" size={14} />
            Active Plan
          </span>
        </div>
      )}

      {displayPrice?.savings && !isCurrentPlan && (
        <div className="absolute -top-3 right-6 z-10">
          <span className="glass-strong bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-1.5 rounded-full text-xs font-bold shadow-glass">
            Save {displayPrice?.savings}%
          </span>
        </div>
      )}

      <div className="text-center mb-8 pt-4">
        <h3 className="text-2xl font-bold text-foreground mb-4 font-heading">{plan?.name}</h3>
        {isPremium && (
          <p className="text-xs text-muted-foreground -mt-2 mb-2">Limited to two seats</p>
        )}
        <div className="flex items-baseline justify-center gap-2">
          <span className="text-5xl from-foreground to-foreground/70 bg-clip-text text-transparent bg-[rgba(74,56,102,0.702)] font-bold">
            ${displayPrice?.price?.toFixed(2)}
          </span>
          {!isFree && <span className="text-muted-foreground font-medium">/seat</span>}
        </div>
        {displayPrice?.monthlyEquivalent && (
          <p className="text-sm text-muted-foreground mt-3 font-medium">
            ${displayPrice?.monthlyEquivalent}/month billed annually
          </p>
        )}
        {isEnterprise && (
          <p className="text-sm text-muted-foreground mt-3">
            No less than $200 per seat
          </p>
        )}
      </div>

      <div className="mb-8">
        <div className="glass-subtle rounded-2xl p-4 text-center">
          <p className="text-sm text-muted-foreground mb-1">Agent Limit</p>
          <p className="text-2xl font-bold text-foreground">{plan?.max_agents}</p>
          <p className="text-xs text-muted-foreground mt-1">Active Agents</p>
        </div>
      </div>

      <ul className="space-y-4 mb-8">
        {plan?.features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-3 group">
            <div className="flex-shrink-0 w-6 h-6 rounded-lg bg-primary/10 flex items-center justify-center mt-0.5 group-hover:bg-primary/20 transition-colors duration-200">
              <Icon
                name="Check"
                size={16}
                className="text-primary"
              />
            </div>
            <span className="text-sm text-foreground leading-relaxed">{feature}</span>
          </li>
        ))}
      </ul>

      {isEnterprise ? (
        <div className="space-y-3">
          <a href="tel:612-545-8283">
            <Button
              variant="default"
              size="lg"
              className="w-full shadow-lg hover:shadow-xl"
              iconName="Phone"
              iconPosition="left"
            >
              Call: 612-545-8283
            </Button>
          </a>
          <a href="mailto:marco1strand@gmail.com">
            <Button
              variant="outline"
              size="lg"
              className="w-full glass-subtle hover:glass-strong"
              iconName="Mail"
              iconPosition="left"
            >
              Email Sales
            </Button>
          </a>
        </div>
      ) : (
        <Button
          variant={isPremium ? 'default' : 'outline'}
          size="lg"
          className={`w-full shadow-lg hover:shadow-xl transition-all duration-300 ${
            isPremium ? 'bg-gradient-to-r from-primary to-purple-600 hover:from-primary/90 hover:to-purple-600/90' : 'glass-subtle hover:glass-strong'
          }`}
          onClick={handleClick}
          disabled={isCurrentPlan || isProcessing}
        >
          {getButtonText()}
        </Button>
      )}
    </div>
  )
}

export default PricingCard